const theme = {
	config: {
		useLocalStorage: false,
		initialColorModeName: 'gf-p'
	},
	useLocalStorage: false,
	space: [
		0,
		4,
		8,
		16,
		30,
		64,
		128,
		256,
		512
	],
	breakpoints: [
		'768px',
		'1024px'
	],
	fonts: {
		body: 'Sofia-Regular, system-ui, sans-serif',
		heading: 'Sofia, system-ui, sans-serif',
		monospace: 'Pitch, monospace',
		secondary: 'Marby, system-ui, sans-serif',
		hebrew: 'Haglida Mono, system-ui, sans-serif'
	},
	fontSizes: [
		12,
		14,
		16,
		20,
		24,
		36,
		48,
		64,
		96,
		100
	],
	fontWeights: {
		body: 400,
		bold: 600,
		extraBold: 700,
		heading: 900
	},
	lineHeights: {
		body: 1.5,
		heading: 1
	},
	borderWidths: {
		borderWidth: 2
	},
	colors: {
		primary: '#F752AD',
		primaryAlt: '#F752AD',
		japaneseLaurel: '#007300',
		brightBlue: '#87EFF0',
		waxFlower: '#FFB699',
		blazeOrange: '#FF5600',
		supernova: '#F9C600',
		brilliantRose: '#F752AD',
		grape: '#6E5BE8',
		frenchPass: '#AEE0FD',
		robinsEggBlue: '#3FCFC2',
		governorBay: '#2B38BD',
		schoolBusYellow: '#FFDD00',
		mayaBlue: '#67C7ED',
		blue: '#2B38BD',
		yellow: '#FFDD00',
		pink: '#FFC8D0',
		lightPink: '#FFACB9',
		sunsetOrange: '#FF5A47',
		red: '#FF2815',
		goodlesRed: '#FF2815',
		electricViolet: '#8821EB',
		azureRadiance: '#008BFA',
		modes: {
			Cart: {
				primary: '#FF5A47',
				secondary: '#2B38BD',
				accent: '#FFDD00',
				tertiary: '#FF2815',
				background: '#F7EFD9',
				override: {
					logo: {
						logoFront: '#FFDD00',
						logoBack: '#2B38BD',
						altLogoFront: '#FFDD00',
						altLogoBack: '#2B38BD'
					},
					footerBackground: '#FFDD00',
					footerColor: '#FF5A47'
				}
			},
			Home: {
				secondary: '#007300',
				accent: '#FFDD00',
				tertiary: '#FF5400',
				error: '#FF5A47',
				primary: '#3FCFC2',
				background: '3FCFC2',
				red: '#FF2815',
				schoolBusYellow: '#FFDD00',
				mac: {
					primary: '#2B38BD',
					secondary: '#FFDD00'
				},
				override: {
					secondary: '#007300',
					logo: {
						logoFront: '#FFDD00',
						logoBack: '#6E5BE8',
						altLogoFront: '#3FCFC2',
						altLogoBack: '#007300'
					},
					hero: '#007300',
					detailBackground: 'white',
					detailMain: '#FFC8D0',
					bowlOutline: '#FFC8D0',
					stickyATCBorder: '#FFC8D0',
					stickATCColor: '#FFDD00',
					altButtonBackground: '#FFDD00',
					altButtonColor: '#007300',
					footerColor: '#FF2815',
					footerBackground: '#FFDD00',
					sectionBackground: '#FFDD00',
					press: {
						button: {
							back: '#FFDD00',
							color: '#007300',
							hover: {
								back: '#FF2815',
								color: '#007300'
							}
						}
					}
				}
			},
			PCP: {
				primary: '#F752AD',
				secondary: '#FFDD00',
				accent: '#FFC8D0',
				tertiary: '#FF5400',
				error: '#FF5A47',
				background: '#F752AD',
				mac: {
					primary: '#2B38BD',
					secondary: '#FFDD00'
				},
				override: {
					logo: {
						logoFront: '#FFDD00',
						logoBack: '#6E5BE8',
						altLogoFront: '#F752AD',
						altLogoBack: '#FFDD00'
					},
					detailBackground: 'white',
					detailMain: '#FFC8D0',
					bowlOutline: '#FFC8D0',
					stickyATCBorder: '#FFC8D0',
					stickATCColor: '#FFDD00',
					altButtonBackground: '#FFC8D0',
					altButtonColor: '#2B38BD',
					footerColor: '#FFC8D0',
					footerBackground: '#F752AD',
					sectionBackground: '#FFDD00',
					waitlistBg: '#FFC8D0',
					waitlistColor: '#FF5400'
				}
			},
			CDP: {
				'mac-and-cheese': 'governorBay',
				pasta: 'brilliantRose',
				goods: 'electricViolet',
				'variety-packs': 'japaneseLaurel',
				gifts: 'azureRadiance',
				'gifts-international': 'azureRadiance',
				defaultBackground: 'red',
				defaultText: 'schoolBusYellow',
				transparent: 'transparent',
				shop: '#FFFFBD'
			},
			'Our-Story': {
				primary: '#87efd3',
				secondary: '#8821EB',
				background: '#87efd3',
				override: {
					logo: {
						logoFront: '#45EEFF',
						logoBack: '#8821EB',
						altLogoFront: '#87efd3',
						altLogoBack: '#FF5A47'
					},
					footerColor: '#45EEFF',
					footerBackground: '#8821EB'
				}
			},
			'Gift-Flow': {
				primary: '#2B38BD',
				secondary: '#007300',
				tertiary: '#FFDE00',
				background: '#3FCFC2',
				lightPurple: '#AEE0FD',
				middleBackground: '#007300',
				override: {
					logo: {
						logoFront: '#FFDE00',
						logoBack: '#FF2815',
						altLogoFront: '#3FCFC2',
						altLogoBack: '#007300'
					},
					footerColor: '#FF2815',
					footerBackground: '#FFDE00'
				}
			},
			'Gift-Flow-Form': {
				primary: '#2B38BD',
				secondary: '#AEE0FD',
				tertiary: '#CBC2FF',
				background: '#6E5BE8',
				error: '#FFB699',
				blue: '#2B38BD',
				yellow: '#FFDE00',
				override: {
					logo: {
						logoFront: '#FFB699',
						logoBack: '#FF5A47',
						altLogoFront: '#AEE0FD',
						altLogoBack: '#6E5BE8'
					},
					footerColor: '#FFB699',
					footerBackground: '#FF5A47'
				}
			},
			'Contact-Us': {
				primary: '#6e5be8',
				secondary: '#AEE0FD',
				background: '#6E5BE8',
				override: {
					logo: {
						logoFront: '#FFB699',
						logoBack: '#FF5A47',
						altLogoFront: '#AEE0FD',
						altLogoBack: '#6E5BE8'
					},
					footerColor: '#FFB699',
					footerBackground: '#FF5A47'
				}
			},
			FAQ: {
				primary: '#2b38bd',
				secondary: '#AEE0FD',
				background: '#2B38BD',
				override: {
					logo: {
						logoFront: '#FFB699',
						logoBack: '#FF5A47',
						altLogoFront: '#AEE0FD',
						altLogoBack: '#2B38BD'
					},
					footerColor: '#FFB699',
					footerBackground: '#FF5A47'
				}
			},
			'Us-Vs-Them': {
				primary: '#6e5be8',
				secondary: '#AEE0FD',
				background: '#6E5BE8',
				override: {
					logo: {
						logoFront: '#FFDD00',
						logoBack: '#2B38BD',
						altLogoFront: '#AEE0FD',
						altLogoBack: '#6E5BE8'
					},
					footerColor: '#FFB699',
					footerBackground: '#FF5A47'
				}
			},
			OPE: {
				primary: '#B2FF28',
				secondary: '#FFDD00',
				accent: '#FFC8D0',
				tertiary: '#8821EB',
				error: '#FF5A47',
				background: '#B2FF28',
				mac: {
					primary: '#2B38BD',
					secondary: '#FFDD00'
				},
				override: {
					logo: {
						logoFront: '#FFDD00',
						logoBack: '#6E5BE8',
						altLogoFront: '#B2FF28',
						altLogoBack: '#FFDD00'
					},
					detailBackground: 'white',
					detailMain: '#FFC8D0',
					bowlOutline: '#8821EB',
					stickyATCBorder: '#8821EB',
					stickATCColor: '#FFDD00',
					altButtonBackground: '#8821EB',
					altButtonColor: '#2B38BD',
					footerColor: '#8821EB',
					footerBackground: '#B2FF28',
					sectionBackground: '#FFDD00'
				}
			},
			CNF: {
				primary: '#C3F5D3',
				secondary: '#2B38BD',
				accent: '#FFB699',
				secondTxt: '#FF5600',
				tertiary: '#FFDD00',
				error: '#FF5A47',
				background: '#C3F5D3',
				text: '#2B38BD',
				scndBg: '#FFB699',
				scndTxt: '#FF5600',
				override: {
					logo: {
						logoFront: '#FFB699',
						logoBack: '#FF5600',
						altLogoFront: '#C3F5D3',
						altLogoBack: '#2B38BD'
					},
					footerBackground: '#FFB699',
					footerColor: '#FF5600'
				}
			},
			'Blog-Pink': {
				primary: '#F752AD',
				secondary: '#FFB699',
				accent: '#FFDD00',
				error: '#FF5A47',
				background: '#F752AD',
				text: '#FFB699',
				override: {
					footerBackground: '#CBC2FF',
					footerColor: '#6E5BE8',
					logo: {
						logoFront: '#CBC2FF',
						logoBack: '#6E5BE8',
						altLogoFront: '#FFB699',
						altLogoBack: '#F752AD'
					}
				}
			},
			'Blog-Green': {
				primary: '#007300',
				secondary: '#C3F5D3',
				accent: '#FFDD00',
				error: '#FF5A47',
				background: '#007300',
				text: '#C3F5D3',
				override: {
					footerBackground: '#FFB699',
					footerColor: '#F752AD',
					logo: {
						logoFront: '#FFB699',
						logoBack: '#F752AD',
						altLogoFront: '#CBC2FF',
						altLogoBack: '#6E5BE8'
					}
				}
			},
			'Blog-Blue': {
				primary: '#6E5BE8',
				secondary: '#CBC2FF',
				accent: '#FFDD00',
				error: '#FF5A47',
				background: '#6E5BE8',
				text: '#CBC2FF',
				override: {
					footerBackground: '#FFB699',
					footerColor: '#F752AD',
					logo: {
						logoFront: '#FFB699',
						logoBack: '#F752AD',
						altLogoFront: '#CBC2FF',
						altLogoBack: '#6E5BE8'
					}
				}
			},
			'club-house': {
				primary: '#44B8F3',
				secondary: '#FFDD00',
				tertiary: '#273376',
				accent: '#45EEFF',
				error: '#8821EB',
				background: '#44B8F3',
				override: {
					logo: {
						logoFront: '#45EEFF',
						logoBack: '#273376',
						altLogoFront: '#FFDD00',
						altLogoBack: '#44B8F3'
					},
					detailBackground: 'white',
					detailMain: '#273376',
					bowlOutline: '#45EEFF',
					stickyATCBorder: '#273376',
					stickyATCColor: '#273376',
					stickyATCBg: '#45EEFF',
					altButtonBackground: '#273376',
					altButtonColor: '#FFDD00',
					footerColor: '#273376',
					footerBackground: '#45EEFF',
					sectionBackground: '#FFDD00',
					sectionBackgroundAlt: '#44B8F3',
					sectionColorAlt: '#FFDD00',
					waitlistBg: '#45EEFF',
					waitlistColor: '#273376',
					ingredientsBg: '#FFDD00',
					ingredientsText: '#44B8F3'
				}
			},
			'thrilled-cheese': {
				primary: '#fff297',
				secondary: '#f32f40',
				tertiary: '#2e37b7',
				accent: '#6ce2f2',
				error: '#8821EB',
				background: '#fff297',
				override: {
					logo: {
						logoFront: '#6ce2f2',
						logoBack: '#2e37b7',
						altLogoFront: '#f32f40',
						altLogoBack: '#fff297'
					},
					detailBackground: 'white',
					detailMain: '#2e37b7',
					bowlOutline: '#6ce2f2',
					stickyATCBorder: '#2e37b7',
					stickyATCColor: '#2e37b7',
					stickyATCBg: '#6ce2f2',
					altButtonBackground: '#2e37b7',
					altButtonColor: '#FFDD00',
					footerColor: '#2e37b7',
					footerBackground: '#6ce2f2',
					sectionBackground: '#f32f40',
					sectionBackgroundAlt: '#fff297',
					sectionColorAlt: '#f32f40',
					waitlistBg: '#6ce2f2',
					waitlistColor: '#2e37b7',
					ingredientsBg: '#f32f40',
					ingredientsText: '#fff297'
				}
			},
			'dreamy-creamy': {
				primary: '#6776c1',
				secondary: '#addaeb',
				tertiary: '#273376',
				accent: '#45EEFF',
				error: '#8821EB',
				background: '#6776c1',
				override: {
					logo: {
						logoFront: '#45EEFF',
						logoBack: '#273376',
						altLogoFront: '#addaeb',
						altLogoBack: '#6776c1'
					},
					detailBackground: 'white',
					detailMain: '#273376',
					bowlOutline: '#45EEFF',
					stickyATCBorder: '#273376',
					stickyATCColor: '#273376',
					stickyATCBg: '#45EEFF',
					altButtonBackground: '#273376',
					altButtonColor: '#FFDD00',
					footerColor: '#273376',
					footerBackground: '#45EEFF',
					sectionBackground: '#addaeb',
					sectionBackgroundAlt: '#6776c1',
					sectionColorAlt: '#addaeb',
					waitlistBg: '#45EEFF',
					waitlistColor: '#273376',
					ingredientsBg: '#addaeb',
					ingredientsText: '#6776c1'
				}
			},
			'queso-tell-me-more': {
				primary: '#fc5997',
				secondary: '#ffc5d4',
				tertiary: '#2e37b7',
				accent: '#FFEE00',
				error: '#FFEE00',
				background: '#fc5997',
				override: {
					logo: {
						logoFront: '#FFEE00',
						logoBack: '#2e37b7',
						altLogoFront: '#ffc5d4',
						altLogoBack: '#fc5997'
					},
					detailBackground: 'white',
					detailMain: '#2e37b7',
					bowlOutline: '#FFEE00',
					stickyATCBorder: '#2e37b7',
					stickyATCColor: '#2e37b7',
					stickyATCBg: '#FFEE00',
					altButtonBackground: '#2e37b7',
					altButtonColor: '#FFDD00',
					footerColor: '#2e37b7',
					footerBackground: '#FFEE00',
					sectionBackground: '#ffc5d4',
					sectionBackgroundAlt: '#fc5997',
					sectionColorAlt: '#ffc5d4',
					waitlistBg: '#FFEE00',
					waitlistColor: '#2e37b7',
					ingredientsBg: '#ffc5d4',
					ingredientsText: '#fc5997'
				}
			},
			'gf-p': {
				primary: '#F49EC3',
				secondary: '#6F1D46',
				tertiary: '#FF5400',
				accent: '#FFC8D0',
				error: '#FF5A47',
				background: '#F49EC3',
				override: {
					logo: {
						logoFront: '#FFC8D0',
						logoBack: '#FF5400',
						altLogoFront: '#6F1D46',
						altLogoBack: '#F49EC3'
					},
					detailBackground: 'white',
					detailMain: '#FF5400',
					bowlOutline: '#FFC8D0',
					stickyATCBorder: '#FF5400',
					stickyATCColor: '#FF5400',
					stickyATCBg: '#FFC8D0',
					altButtonBackground: '#FF5400',
					altButtonColor: '#FFDD00',
					footerColor: '#FF5400',
					footerBackground: '#FFC8D0',
					sectionBackground: '#6F1D46',
					sectionBackgroundAlt: '#F49EC3',
					sectionColorAlt: '#6F1D46',
					waitlistBg: '#FFC8D0',
					waitlistColor: '#FF5400',
					ingredientsBg: '#6F1D46',
					ingredientsText: '#F49EC3'
				}
			},
			'shell-we-dance': {
				primary: '#72C593',
				secondary: '#AF0578',
				tertiary: '#F2A5C8',
				accent: '#036c77',
				error: '#F2A5C8',
				background: '#72C593',
				override: {
					logo: {
						logoFront: '#036c77',
						logoBack: '#F2A5C8',
						altLogoFront: '#AF0578',
						altLogoBack: '#72C593'
					},
					detailBackground: 'white',
					detailMain: '#F2A5C8',
					bowlOutline: '#036c77',
					stickyATCBorder: '#F2A5C8',
					stickyATCColor: '#F2A5C8',
					stickyATCBg: '#036c77',
					altButtonBackground: '#F2A5C8',
					altButtonColor: '#FFDD00',
					footerColor: '#F2A5C8',
					footerBackground: '#036c77',
					sectionBackground: '#AF0578',
					sectionBackgroundAlt: '#72C593',
					sectionColorAlt: '#AF0578',
					waitlistBg: '#036c77',
					waitlistColor: '#F2A5C8',
					ingredientsBg: '#AF0578',
					ingredientsText: '#72C593'
				}
			},
			'ched-over-heels': {
				primary: '#5757bc',
				secondary: '#38e9ff',
				tertiary: '#FAA819',
				accent: '#FFEE00',
				error: '#FFEE00',
				background: '#5757bc',
				override: {
					logo: {
						logoFront: '#FFEE00',
						logoBack: '#FAA819',
						altLogoFront: '#38e9ff',
						altLogoBack: '#5757bc'
					},
					detailBackground: 'white',
					detailMain: '#FAA819',
					bowlOutline: '#FFEE00',
					stickyATCBorder: '#FAA819',
					stickyATCColor: '#FAA819',
					stickyATCBg: '#FFEE00',
					altButtonBackground: '#FAA819',
					altButtonColor: '#FFDD00',
					footerColor: '#FAA819',
					footerBackground: '#FFEE00',
					sectionBackground: '#38e9ff',
					sectionBackgroundAlt: '#5757bc',
					sectionColorAlt: '#38e9ff',
					waitlistBg: '#FFEE00',
					waitlistColor: '#FAA819',
					ingredientsBg: '#38e9ff',
					ingredientsText: '#5757bc'
				}
			},
			'bling-bling-bacn': {
				primary: '#88394c',
				secondary: '#f7b2c1',
				tertiary: '#ee4f9c',
				accent: '#ffda00',
				error: '#ffda00',
				background: '#88394c',
				override: {
					logo: {
						logoFront: '#ffda00',
						logoBack: '#ee4f9c',
						altLogoFront: '#f7b2c1',
						altLogoBack: '#88394c'
					},
					detailBackground: 'white',
					detailMain: '#ee4f9c',
					bowlOutline: '#ffda00',
					stickyATCBorder: '#ee4f9c',
					stickyATCColor: '#ee4f9c',
					stickyATCBg: '#ffda00',
					altButtonBackground: '#ee4f9c',
					altButtonColor: '#FFDD00',
					footerColor: '#ee4f9c',
					footerBackground: '#ffda00',
					sectionBackground: '#f7b2c1',
					sectionBackgroundAlt: '#88394c',
					sectionColorAlt: '#f7b2c1',
					waitlistBg: '#ffda00',
					waitlistColor: '#ee4f9c',
					ingredientsBg: '#f7b2c1',
					ingredientsText: '#88394c'
				}
			},
			'gf-cheddy-mac': {
				primary: '#19d3c5',
				secondary: '#006241',
				tertiary: '#fed103',
				accent: '#f5333f',
				error: '#f5333f',
				background: '#19d3c5',
				override: {
					logo: {
						logoFront: '#f5333f',
						logoBack: '#fed103',
						altLogoFront: '#006241',
						altLogoBack: '#19d3c5'
					},
					detailBackground: 'white',
					detailMain: '#fed103',
					bowlOutline: '#f5333f',
					stickyATCBorder: '#fed103',
					stickyATCColor: '#fed103',
					stickyATCBg: '#f5333f',
					altButtonBackground: '#fed103',
					altButtonColor: '#FFDD00',
					footerColor: '#fed103',
					footerBackground: '#f5333f',
					sectionBackground: '#006241',
					sectionBackgroundAlt: '#19d3c5',
					sectionColorAlt: '#006241',
					waitlistBg: '#f5333f',
					waitlistColor: '#fed103',
					ingredientsBg: '#006241',
					ingredientsText: '#19d3c5'
				}
			},
			'vegan-be-heroes': {
				primary: '#93d500',
				secondary: '#773dbd',
				tertiary: '#773dbd',
				accent: '#c19ade',
				error: '#c19ade',
				background: '#93d500',
				override: {
					logo: {
						logoFront: '#c19ade',
						logoBack: '#773dbd',
						altLogoFront: '#773dbd',
						altLogoBack: '#93d500'
					},
					detailBackground: 'white',
					detailMain: '#773dbd',
					bowlOutline: '#c19ade',
					stickyATCBorder: '#773dbd',
					stickyATCColor: '#773dbd',
					stickyATCBg: '#c19ade',
					altButtonBackground: '#773dbd',
					altButtonColor: '#FFDD00',
					footerColor: '#773dbd',
					footerBackground: '#c19ade',
					sectionBackground: '#773dbd',
					sectionBackgroundAlt: '#93d500',
					sectionColorAlt: '#773dbd',
					waitlistBg: '#c19ade',
					waitlistColor: '#773dbd',
					ingredientsBg: '#773dbd',
					ingredientsText: '#93d500'
				}
			},
			'default-product-1': {
				primary: '#F652AC',
				secondary: '#ffdd04',
				tertiary: '#FF5400',
				accent: '#FFC8D0',
				error: '#FF5A47',
				background: '#F652AC',
				override: {
					logo: {
						logoFront: '#FFC8D0',
						logoBack: '#FF5400',
						altLogoFront: '#ffdd04',
						altLogoBack: '#F652AC'
					},
					detailBackground: 'white',
					detailMain: '#FF5400',
					bowlOutline: '#FFC8D0',
					stickyATCBorder: '#FF5400',
					stickyATCColor: '#FF5400',
					stickyATCBg: '#FFC8D0',
					altButtonBackground: '#FF5400',
					altButtonColor: '#FFDD00',
					footerColor: '#FF5400',
					footerBackground: '#FFC8D0',
					sectionBackground: '#ffdd04',
					sectionBackgroundAlt: '#F652AC',
					sectionColorAlt: '#ffdd04',
					waitlistBg: '#FFC8D0',
					waitlistColor: '#FF5400',
					ingredientsBg: '#ffdd04',
					ingredientsText: '#F652AC'
				}
			},
			'smokey-dokey': {
				primary: '#FF8A35',
				secondary: '#8621E9',
				tertiary: '#9b7ae0',
				accent: '#ffacb9',
				error: '#ffacb9',
				background: '#FF8A35',
				override: {
					logo: {
						logoFront: '#ffacb9',
						logoBack: '#9b7ae0',
						altLogoFront: '#8621E9',
						altLogoBack: '#FF8A35'
					},
					detailBackground: 'white',
					detailMain: '#9b7ae0',
					bowlOutline: '#ffacb9',
					stickyATCBorder: '#9b7ae0',
					stickyATCColor: '#9b7ae0',
					stickyATCBg: '#ffacb9',
					altButtonBackground: '#9b7ae0',
					altButtonColor: '#FFDD00',
					footerColor: '#9b7ae0',
					footerBackground: '#ffacb9',
					sectionBackground: '#8621E9',
					sectionBackgroundAlt: '#FF8A35',
					sectionColorAlt: '#8621E9',
					waitlistBg: '#ffacb9',
					waitlistColor: '#9b7ae0',
					ingredientsBg: '#8621E9',
					ingredientsText: '#FF8A35'
				}
			},
			hoppy: {
				primary: '#74c9bc',
				secondary: '#2b2195',
				tertiary: '#93D500',
				accent: '#ffef00',
				error: '#FF5A47',
				background: '#74c9bc',
				override: {
					logo: {
						logoFront: '#ffef00',
						logoBack: '#93D500',
						altLogoFront: '#2b2195',
						altLogoBack: '#74c9bc'
					},
					detailBackground: 'white',
					detailMain: '#93D500',
					bowlOutline: '#ffef00',
					stickyATCBorder: '#93D500',
					stickyATCColor: '#93D500',
					stickyATCBg: '#ffef00',
					altButtonBackground: '#93D500',
					altButtonColor: '#FFDD00',
					footerColor: '#93D500',
					footerBackground: '#ffef00',
					sectionBackground: '#2b2195',
					sectionBackgroundAlt: '#74c9bc',
					sectionColorAlt: '#2b2195',
					waitlistBg: '#ffef00',
					waitlistColor: '#93D500',
					ingredientsBg: '#2b2195',
					ingredientsText: '#74c9bc'
				}
			},
			'hey-hey-elote': {
				primary: '#FFFFBD',
				secondary: '#FF2815',
				tertiary: '#FF2815',
				accent: '#FFACB9',
				error: '#FF5A47',
				background: '#FFFFBD',
				override: {
					logo: {
						logoFront: '#FFACB9',
						logoBack: '#FF2815',
						altLogoFront: '#FF2815',
						altLogoBack: '#FFFFBD'
					},
					detailBackground: 'white',
					detailMain: '#FF2815',
					bowlOutline: '#FFACB9',
					stickyATCBorder: '#FF2815',
					stickyATCColor: '#FF2815',
					stickyATCBg: '#FFACB9',
					altButtonBackground: '#FF2815',
					altButtonColor: '#FFDD00',
					footerColor: '#FF2815',
					footerBackground: '#FFACB9',
					sectionBackground: '#FF2815',
					sectionBackgroundAlt: '#FFFFBD',
					sectionColorAlt: '#FF2815',
					waitlistBg: '#FFACB9',
					waitlistColor: '#FF2815',
					ingredientsBg: '#FF2815',
					ingredientsText: '#FFFFBD'
				}
			},
			'cheddy-mac': {
				primary: '#00E0BE',
				secondary: '#007300',
				tertiary: '#FF2815',
				accent: '#FFDD00',
				error: '#FF5A47',
				background: '#00E0BE',
				override: {
					logo: {
						logoFront: '#FFDD00',
						logoBack: '#FF2815',
						altLogoFront: '#007300',
						altLogoBack: '#00E0BE'
					},
					detailBackground: 'white',
					detailMain: '#FF2815',
					bowlOutline: '#FFDD00',
					stickyATCBorder: '#FF2815',
					stickyATCColor: '#FF2815',
					stickyATCBg: '#FFDD00',
					altButtonBackground: '#FF2815',
					altButtonColor: '#FFDD00',
					footerColor: '#FF2815',
					footerBackground: '#FFDD00',
					sectionBackground: '#007300',
					sectionBackgroundAlt: '#00E0BE',
					sectionColorAlt: '#007300',
					waitlistBg: '#FFDD00',
					waitlistColor: '#FF2815',
					ingredientsBg: '#007300',
					ingredientsText: '#00E0BE'
				}
			},
			'dry-pasta': {
				primary: '#803830',
				secondary: '#FFDD00',
				tertiary: '#F652AC',
				accent: '#181D49',
				error: '#FFDD00',
				backgroundGradient: [
					'linear-gradient(180deg, #181D49 0%, #F652AC 15.31%);',
					'linear-gradient(180deg, #181D49 0%, #F652AC 24.31%);'
				],
				background: '#F652AC',
				override: {
					navFadedBG: '#181D49',
					logo: {
						logoFront: '#181D49',
						logoBack: '#FFDD00',
						altLogoFront: '#FFDD00',
						altLogoBack: '#803830',
						glow: 'drop-shadow(0 0 10px #FFDD00)'
					},
					detailBackground: '#000000',
					detailMain: '#F652AC',
					sectionBackground: '#FFDD00',
					bowlOutline: '#181D49',
					stickyATCBorder: '#803830',
					stickyATCColor: '#803830',
					stickyATCBg: '#FFDD00',
					altButtonBackground: '#F652AC',
					altButtonColor: '#FFDD00',
					footerColor: '#803830',
					footerBackground: '#FFDD00',
					waitlistBg: '#181D49',
					waitlistColor: '#F652AC',
					addButtonColor: '#F652AC',
					addButtonBG: '#FFDD00',
					addButtonColorAlt: '#FFDD00',
					addButtonBGAlt: '#F652AC',
					ingredientsContainer: '#803830',
					ingredientsText: '#803830',
					ingredientsBg: '#FFDD00'
				}
			},
			'default-product': {
				primary: '#C3F5D3',
				secondary: '#6E5BE8',
				tertiary: '#FF5400',
				accent: '#FFC8D0',
				error: '#FF5A47',
				background: '#C3F5D3',
				override: {
					logo: {
						logoFront: '#FFC8D0',
						logoBack: '#FF5400',
						altLogoFront: '#6E5BE8',
						altLogoBack: '#C3F5D3'
					},
					detailBackground: 'white',
					detailMain: '#FF5400',
					bowlOutline: '#FFC8D0',
					stickyATCBorder: '#FF5400',
					stickyATCColor: '#FF5400',
					stickyATCBg: '#FFC8D0',
					altButtonBackground: '#FF5400',
					altButtonColor: '#FFDD00',
					footerColor: '#FF5400',
					footerBackground: '#FFC8D0',
					sectionBackground: '#6E5BE8',
					sectionBackgroundAlt: '#C3F5D3',
					sectionColorAlt: '#6E5BE8',
					waitlistBg: '#FFC8D0',
					waitlistColor: '#FF5400',
					ingredientsBg: '#6E5BE8',
					ingredientsText: '#C3F5D3'
				}
			},
			'vegan-is-believin': {
				primary: '#71FF00',
				secondary: '#007300',
				tertiary: '#6027b4',
				accent: '#45efff',
				error: '#FF5A47',
				background: '#71FF00',
				override: {
					logo: {
						logoFront: '#45efff',
						logoBack: '#6027b4',
						altLogoFront: '#007300',
						altLogoBack: '#71FF00'
					},
					detailBackground: 'white',
					detailMain: '#6027b4',
					bowlOutline: '#45efff',
					stickyATCBorder: '#6027b4',
					stickyATCColor: '#6027b4',
					stickyATCBg: '#45efff',
					altButtonBackground: '#6027b4',
					altButtonColor: '#FFDD00',
					footerColor: '#6027b4',
					footerBackground: '#45efff',
					sectionBackground: '#007300',
					sectionBackgroundAlt: '#71FF00',
					sectionColorAlt: '#007300',
					waitlistBg: '#45efff',
					waitlistColor: '#6027b4',
					ingredientsBg: '#007300',
					ingredientsText: '#71FF00'
				}
			},
			'here-comes-truffle': {
				primary: '#036c77',
				secondary: '#87eff0',
				tertiary: '#FF2815',
				accent: '#FFACB9',
				error: '#FF5A47',
				background: '#036c77',
				override: {
					logo: {
						logoFront: '#FFACB9',
						logoBack: '#FF2815',
						altLogoFront: '#87eff0',
						altLogoBack: '#036c77'
					},
					detailBackground: 'white',
					detailMain: '#FF2815',
					bowlOutline: '#FFACB9',
					stickyATCBorder: '#FF2815',
					stickyATCColor: '#FF2815',
					stickyATCBg: '#FFACB9',
					altButtonBackground: '#FF2815',
					altButtonColor: '#FFDD00',
					footerColor: '#FF2815',
					footerBackground: '#FFACB9',
					sectionBackground: '#87eff0',
					sectionBackgroundAlt: '#036c77',
					sectionColorAlt: '#87eff0',
					waitlistBg: '#FFACB9',
					waitlistColor: '#FF2815',
					ingredientsBg: '#87eff0',
					ingredientsText: '#036c77'
				}
			},
			'shella-good': {
				primary: '#FF5A47',
				secondary: '#FFDD00',
				tertiary: '#2B38BD',
				accent: '#45EEFF',
				error: '#8821EB',
				background: '#FF5A47',
				override: {
					logo: {
						logoFront: '#45EEFF',
						logoBack: '#2B38BD',
						altLogoFront: '#FFDD00',
						altLogoBack: '#FF5A47'
					},
					detailBackground: 'white',
					detailMain: '#2B38BD',
					bowlOutline: '#45EEFF',
					stickyATCBorder: '#2B38BD',
					stickyATCColor: '#2B38BD',
					stickyATCBg: '#45EEFF',
					altButtonBackground: '#2B38BD',
					altButtonColor: '#FFDD00',
					footerColor: '#2B38BD',
					footerBackground: '#45EEFF',
					sectionBackground: '#FFDD00',
					sectionBackgroundAlt: '#FF5A47',
					sectionColorAlt: '#FFDD00',
					waitlistBg: '#45EEFF',
					waitlistColor: '#2B38BD',
					ingredientsBg: '#FFDD00',
					ingredientsText: '#FF5A47'
				}
			},
			'down-the-hatch': {
				primary: '#007300',
				secondary: '#87EFF0',
				tertiary: '#FF2815',
				accent: '#FFACB9',
				error: '#FF5A47',
				background: '#007300',
				override: {
					logo: {
						logoFront: '#FFACB9',
						logoBack: '#FF2815',
						altLogoFront: '#87EFF0',
						altLogoBack: '#007300'
					},
					detailBackground: 'white',
					detailMain: '#FF2815',
					bowlOutline: '#FFACB9',
					stickyATCBorder: '#FF2815',
					stickyATCColor: '#FF2815',
					stickyATCBg: '#FFACB9',
					altButtonBackground: '#FF2815',
					altButtonColor: '#FFDD00',
					footerColor: '#FF2815',
					footerBackground: '#FFACB9',
					sectionBackground: '#87EFF0',
					sectionBackgroundAlt: '#007300',
					sectionColorAlt: '#87EFF0',
					waitlistBg: '#FFACB9',
					waitlistColor: '#FF2815',
					ingredientsBg: '#87EFF0',
					ingredientsText: '#007300'
				}
			},
			'mover-shaker': {
				primary: '#6027B4',
				secondary: '#00C9FF',
				tertiary: '#FF5400',
				accent: '#FFACB9',
				error: '#FF5A47',
				background: '#6027B4',
				override: {
					logo: {
						logoFront: '#FFACB9',
						logoBack: '#FF5400',
						altLogoFront: '#00C9FF',
						altLogoBack: '#6027B4'
					},
					detailBackground: 'white',
					detailMain: '#FF5400',
					bowlOutline: '#FFACB9',
					stickyATCBorder: '#FF5400',
					stickyATCColor: '#FF5400',
					stickyATCBg: '#FFACB9',
					altButtonBackground: '#FF5400',
					altButtonColor: '#FFDD00',
					footerColor: '#FF5400',
					footerBackground: '#FFACB9',
					sectionBackground: '#00C9FF',
					sectionBackgroundAlt: '#6027B4',
					sectionColorAlt: '#00C9FF',
					waitlistBg: '#FFACB9',
					waitlistColor: '#FF5400',
					ingredientsBg: '#00C9FF',
					ingredientsText: '#6027B4'
				}
			},
			'twist-my-parm': {
				primary: '#45EEFF',
				secondary: '#7833DE',
				tertiary: '#2B38BD',
				accent: '#FFDD00',
				error: '#FF5A47',
				background: '#45EEFF',
				override: {
					logo: {
						logoFront: '#FFDD00',
						logoBack: '#2B38BD',
						altLogoFront: '#7833DE',
						altLogoBack: '#45EEFF'
					},
					detailBackground: 'white',
					detailMain: '#2B38BD',
					bowlOutline: '#FFDD00',
					stickyATCBorder: '#2B38BD',
					stickyATCColor: '#2B38BD',
					stickyATCBg: '#FFDD00',
					altButtonBackground: '#2B38BD',
					altButtonColor: '#FFDD00',
					footerColor: '#2B38BD',
					footerBackground: '#FFDD00',
					sectionBackground: '#7833DE',
					sectionBackgroundAlt: '#45EEFF',
					sectionColorAlt: '#7833DE',
					waitlistBg: '#FFDD00',
					waitlistColor: '#2B38BD',
					ingredientsBg: '#7833DE',
					ingredientsText: '#45EEFF'
				}
			}
		}
	},
	styles: {
		root: {
			variant: 'text.body',
			a: {
				color: 'inherit',
				textDecoration: 'none'
			}
		}
	},
	forms: {
		input: {
			color: 'currentColor',
			borderColor: 'currentColor',
			'&:focus': {
				color: 'currentColor',
				borderColor: 'currentColor',
				boxShadow: '0 0 0 2px',
				boxShadowColor: 'currentColor',
				outline: 'none'
			},
			minicart: {
				variant: 'input',
				background: 'white',
				color: '#FF5A47',
				borderColor: '#FF5A47',
				'&:focus': {
					borderColor: '#FF5A47',
					boxShadow: 'inset 0 0 0 2px',
					boxShadowColor: '#FF5A47',
					outline: 'none'
				}
			},
			gift: {
				backgroundColor: 'white',
				borderRadius: 8,
				height: 48,
				padding: '10px 20px',
				border: 'unset'
			}
		},
		radio: {
			'input ~ &': {
				border: '1px solid',
				borderColor: 'override.detailMain',
				color: 'transparent'
			},
			'input:checked ~ &': {
				border: ' 5px solid',
				borderColor: 'override.detailMain',
				backgroundColor: 'override.detailBackground',
				color: 'override.detailBackground'
			}
		},
		select: {
			width: 'inherit',
			borderRadius: '8px',
			borderWidth: 2,
			background: 'white',
			color: 'tertiary',
			fontWeight: 'bold',
			borderColor: 'tertiary',
			fontSize: 16,
			paddingTop: 11,
			paddingBottom: 10,
			paddingLeft: 20
		},
		checkbox: {
			color: 'white',
			backgroundColor: 'unset !important'
		}
	},
	buttons: {
		primary: {
			backgroundColor: 'tertiary',
			borderRadius: '8px',
			color: 'secondary',
			cursor: 'pointer',
			fontFamily: 'heading',
			width: 200,
			fontSize: '1.25rem',
			lineHeight: 1,
			minHeight: '50px',
			padding: '0.875rem 1.125rem',
			whiteSpace: 'nowrap',
			transition: 'all 0.1s ease',
			'&:hover': {
				backgroundColor: 'secondary',
				color: 'tertiary'
			},
			'&:disabled, [disabled]': {
				opacity: 0.5,
				cursor: 'not-allowed'
			}
		},
		gift: {
			primary: {
				backgroundColor: 'tertiary',
				borderRadius: '8px',
				color: 'primary',
				cursor: 'pointer',
				fontFamily: 'heading',
				width: 'fit-content',
				fontSize: '1.25rem',
				lineHeight: 1,
				minHeight: '50px',
				padding: '0px 30px',
				whiteSpace: 'nowrap',
				transition: 'all 0.1s ease',
				'&:hover': {
					backgroundColor: 'secondary',
					color: 'tertiary'
				},
				'&:disabled, [disabled]': {
					opacity: 0.5,
					cursor: 'not-allowed'
				},
				':hover': {
					color: 'tertiary',
					backgroundColor: 'primary'
				}
			},
			secondary: {
				backgroundColor: 'primary',
				borderRadius: '8px',
				color: 'tertiary',
				cursor: 'pointer',
				fontFamily: 'heading',
				width: 'fit-content',
				fontSize: '1.25rem',
				lineHeight: 1,
				minHeight: '50px',
				padding: '0px 30px',
				whiteSpace: 'nowrap',
				transition: 'all 0.1s ease',
				'&:hover': {
					backgroundColor: 'secondary',
					color: 'tertiary'
				},
				'&:disabled, [disabled]': {
					opacity: 0.5,
					cursor: 'not-allowed'
				},
				':hover': {
					backgroundColor: 'tertiary',
					color: 'primary'
				}
			},
			form: {
				backgroundColor: '#2B38BD',
				borderRadius: '8px',
				color: '#FFDE00',
				cursor: 'pointer',
				fontFamily: 'heading',
				width: 'fit-content',
				fontSize: '1.25rem',
				lineHeight: 1,
				minHeight: '50px',
				padding: '0px 30px',
				whiteSpace: 'nowrap',
				transition: 'all 0.1s ease',
				'&:hover': {
					backgroundColor: 'secondary',
					color: 'tertiary'
				},
				'&:disabled, [disabled]': {
					opacity: 0.5,
					cursor: 'not-allowed'
				},
				':hover': {
					backgroundColor: '#FFDE00',
					color: '#2B38BD'
				},
				inverted: {
					backgroundColor: '#FFDE00',
					borderRadius: '8px',
					color: '#2B38BD',
					cursor: 'pointer',
					fontFamily: 'heading',
					width: 'fit-content',
					fontSize: '1.25rem',
					lineHeight: 1,
					minHeight: '50px',
					padding: '0px 30px',
					whiteSpace: 'nowrap',
					transition: 'all 0.1s ease',
					'&:hover': {
						backgroundColor: 'secondary',
						color: 'tertiary'
					},
					'&:disabled, [disabled]': {
						opacity: 0.5,
						cursor: 'not-allowed'
					},
					':hover': {
						backgroundColor: '#2B38BD',
						color: '#FFDE00'
					}
				}
			}
		},
		invert: {
			backgroundColor: 'secondary',
			borderRadius: '8px',
			color: 'tertiary',
			cursor: 'pointer',
			fontFamily: 'heading',
			width: 200,
			fontSize: '1.25rem',
			lineHeight: 1,
			minHeight: '50px',
			padding: '0.875rem 1.125rem',
			whiteSpace: 'nowrap',
			transition: 'all 0.1s ease',
			'&:hover': {
				backgroundColor: 'secondary',
				color: 'tertiary'
			},
			'&:disabled, [disabled]': {
				opacity: 0.5,
				cursor: 'not-allowed'
			},
			':hover': {
				backgroundColor: 'tertiary',
				color: 'secondary'
			}
		},
		subscription: {
			backgroundColor: 'tertiary',
			borderRadius: '8px',
			color: 'secondary',
			cursor: 'pointer',
			fontFamily: 'heading',
			width: 200,
			fontSize: '1.25rem',
			lineHeight: 1,
			minHeight: '50px',
			padding: '0.875rem 1.125rem',
			whiteSpace: 'nowrap',
			transition: 'all 0.1s ease',
			'&:hover': {
				backgroundColor: 'secondary',
				color: 'tertiary'
			},
			'&:disabled, [disabled]': {
				opacity: 0.5,
				cursor: 'not-allowed'
			},
			maxWidth: '138px',
			height: '44px',
			alignItems: 'center'
		},
		radio: {
			boxSizing: 'border-box',
			variant: 'buttons.primary',
			bg: 'white',
			color: 'override.detailMain',
			borderColor: 'override.detailMain',
			boxShadow: '0 0 0 0px',
			boxShadowColor: 'override.detailMain',
			borderRadius: '8px',
			borderStyle: 'solid',
			textTransform: 'capitalize'
		},
		radio_active: {
			variant: 'buttons.radio',
			color: 'override.detailMain',
			boxShadow: '0 0 0 2px',
			WebkitTextStroke: '1.2px',
			WebkitTextStrokeColor: 'override.detailMain',
			bg: 'white'
		},
		link: {
			color: 'secondary',
			backgroundColor: 'transparent',
			fontFamily: 'heading',
			textDecoration: 'underline',
			cursor: 'pointer',
			fontSize: 3
		},
		productCard: {
			alignItems: 'center',
			borderRadius: '8px',
			color: 'var(--theme-ui-colors-mac-secondary)',
			justifyContent: 'center',
			display: 'flex',
			fontSize: [
				'18px',
				'20px'
			],
			width: '70%',
			height: '50px',
			margin: '20px auto',
			fontFamily: 'Sofia',
			background: 'var(--theme-ui-colors-mac-primary)',
			'&:hover': {
				background: '#AEE0FD'
			}
		}
	},
	cards: {
		primary: {
			padding: 2,
			borderRadius: 4
		},
		compact: {
			padding: 1,
			borderRadius: 2,
			border: '1px solid',
			borderColor: 'muted'
		},
		testimonials: {
			'Green & Yellow': {
				backgroundColor: 'japaneseLaurel',
				color: 'schoolBusYellow'
			},
			'Orange & Pink': {
				backgroundColor: 'sunsetOrange',
				color: 'pink'
			},
			'Blue & Blue': {
				backgroundColor: 'governorBay',
				color: 'frenchPass'
			}
		}
	},
	layout: {
		container: {
			margin: 'auto',
			padding: [
				'0 1rem',
				'0 1rem',
				'0 4rem'
			],
			width: '100%'
		},
		tablet: {
			margin: 'auto',
			maxWidth: 'calc(1600px)',
			padding: [
				0,
				null,
				null
			],
			width: '100%'
		},
		fullWidth: {
			padding: [
				0,
				null,
				null
			],
			width: '100%'
		}
	},
	responsive: {
		mobile: {
			display: [
				'block',
				'none',
				'none'
			]
		},
		mobileTablet: {
			display: [
				'block',
				'block',
				'none'
			]
		},
		tablet: {
			display: [
				'none',
				'block',
				'none'
			]
		},
		desktop: {
			display: [
				'none',
				'none',
				'block'
			]
		},
		tabletDesktop: {
			display: [
				'none',
				'block',
				'block'
			]
		}
	},
	text: {
		body: {
			fontFamily: 'body',
			lineHeight: 'body',
			fontWeight: 'body',
			fontSize: 2,
			large: {
				fontFamily: 'body',
				lineHeight: '24px',
				fontWeight: 'body',
				fontSize: '20px'
			}
		},
		small: {
			fontFamily: 'body',
			lineHeight: 'body',
			fontWeight: 'body'
		},
		caps: {
			textTransform: 'uppercase'
		},
		formInput: {
			fontFamily: 'body',
			lineHeight: 'body',
			fontWeight: 'body'
		},
		formLabel: {
			fontFamily: 'body',
			lineHeight: 'body',
			fontWeight: 'body',
			textTransform: 'uppercase'
		},
		formError: {
			fontFamily: 'body',
			lineHeight: 'body',
			fontWeight: 'body',
			textTransform: 'uppercase',
			color: 'errorDark'
		},
		link: {
			color: 'inherit',
			fontFamily: 'body',
			lineHeight: 'body',
			fontWeight: 'body',
			textDecoration: 'none',
			letterSpacing: '2px',
			textTransform: 'uppercase'
		},
		subscription: {
			fontSize: '19px',
			fontWeight: 900,
			color: 'secondary',
			fontFamily: 'heading',
			lineHeight: '24px'
		},
		h1: {
			color: 'inherit',
			fontFamily: 'heading',
			lineHeight: [
				'heading',
				'80px'
			],
			fontWeight: 'heading',
			fontSize: [
				'3rem',
				'100px'
			],
			textTransform: 'uppercase'
		},
		h2: {
			color: 'inherit',
			fontFamily: 'heading',
			lineHeight: 'heading',
			fontWeight: 'heading',
			fontSize: [
				'40px',
				'60px'
			],
			textTransform: 'uppercase'
		},
		h3: {
			color: 'inherit',
			fontFamily: 'heading',
			lineHeight: 'heading',
			fontWeight: 'heading',
			fontSize: [
				'32px',
				'48px'
			],
			textTransform: 'uppercase'
		},
		h4: {
			color: 'inherit',
			fontFamily: 'heading',
			lineHeight: 'heading',
			fontWeight: 'heading',
			fontSize: [
				'32px',
				'36px'
			],
			textTransform: 'uppercase'
		},
		h5: {
			color: 'inherit',
			fontFamily: 'heading',
			lineHeight: 'heading',
			fontWeight: 'heading',
			fontSize: [
				'22px',
				'24px'
			],
			textTransform: 'uppercase'
		},
		eyebrow: {
			fontFamily: 'Marby',
			fontSize: '14px',
			lineHeight: 1,
			uppercase: {
				fontFamily: 'Marby',
				fontSize: '14px',
				lineHeight: 1,
				textTransform: 'uppercase',
				letterSpacing: '.5px'
			}
		}
	}
}

module.exports = theme